/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportCategory = {
    Students: 'Students',
    Classes: 'Classes',
    Enrollments: 'Enrollments',
    Balances: 'Balances',
    Transactions: 'Transactions',
    Attendance: 'Attendance',
    Revenue: 'Revenue',
    Payroll: 'Payroll'
} as const;
export type ReportCategory = typeof ReportCategory[keyof typeof ReportCategory];


export function instanceOfReportCategory(value: any): boolean {
    for (const key in ReportCategory) {
        if (Object.prototype.hasOwnProperty.call(ReportCategory, key)) {
            if (ReportCategory[key as keyof typeof ReportCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportCategoryFromJSON(json: any): ReportCategory {
    return ReportCategoryFromJSONTyped(json, false);
}

export function ReportCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCategory {
    return json as ReportCategory;
}

export function ReportCategoryToJSON(value?: ReportCategory | null): any {
    return value as any;
}

export function ReportCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportCategory {
    return value as ReportCategory;
}

